import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, profile, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-certify-200 border-t-certify-600" />
          <p className="text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }


  // Force onboarding when profile/org context is incomplete
  const onboardingRequired = !!user && !!profile && !profile.organization_id
  const allowedDuringOnboarding = ['/company', '/accept-invite', '/logout']

  if (onboardingRequired && !allowedDuringOnboarding.some((path) => location.pathname.startsWith(path))) {
    return <Navigate to="/company?onboarding=1" replace />
  }

  return <>{children}</>
}
